import AddIcon from "../../../assets/svg/icono_agregar_blue.svg";
type BtnCreateProps ={
    txtBtn:string ,
    openModal:()=> void
  }
  
const BtnCreateCompetenceEvaluation = ({txtBtn,openModal}:BtnCreateProps) => {
  return (
    <button
        id="addPrestacion"
       // onClick={() => createCampaignsModal("0",true, dispatch)}  
       onClick={openModal}  
       className="btnNuevaPrestacion"
     >
       <div className="alineacionBoton">
          <img src={AddIcon} alt="Agregar Prestación" />
          <div className="nombrePrestacion">
           <b><span>{txtBtn}</span> </b>
          </div>
        </div>
    </button> 
  )
}

export default BtnCreateCompetenceEvaluation